import { render } from "./fcmpush.vue?vue&type=template&id=1c39a57d&scoped=true"
import script from "./fcmpush.vue?vue&type=script&lang=js"
export * from "./fcmpush.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c39a57d"]])

export default __exports__